import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatCommonModule,
  MatNativeDateModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBar,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { map, Observable, of, Subject, switchMap } from 'rxjs';
import { fuseAnimations } from 'src/@fuse/animations';
import { FuseConfigService } from 'src/@fuse/services/config.service';
import { FuseSharedModule } from 'src/@fuse/shared.module';
import { KeycloakAuthResponse } from 'src/app/auth/interface/keycloak.auth';
import { UserService } from 'src/app/main/pages/services/user.service';
import { SessionService } from 'src/app/main/pages/services/user/session/session.service';
import { CUSTOM_DATE_FORMATS } from 'src/app/shared';
import { SharedModule } from 'src/app/shared/shared.module';

import { LoadingComponent } from '../../generals/loading/loading.component';
import { WellcomeComponent } from '../../generals/wellcome/wellcome.component';
import { IdentificationResponse } from '../../services/microservices/response/identification.response';
import { ProspectService } from '../../services/prospect.service';
import { ServicesModule } from '../../services/services.module';
import { DataToForgotPassword } from '../forgot-password/object-type/DataToForgotPassword';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    MatDividerModule,
    MatDialogModule,
    MatTableModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    RouterModule,
    SharedModule,
    ServicesModule,
    FlexLayoutModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatCommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSnackBarModule,
    MatMomentDateModule,
    RouterLink,
    FuseSharedModule,
    FlexLayoutModule,
    LoadingComponent,
    WellcomeComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 2500,
        verticalPosition: 'top',
        horizontalPosition: 'right',
      },
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
  encapsulation: ViewEncapsulation.Emulated,
  animations: fuseAnimations,
})
export class LoginComponent implements OnInit, OnDestroy {
  savedSessions: any[];
  username!: string;
  imagenLogin!: any;
  count = 0;
  loginForm!: FormGroup;
  showUsername: boolean;
  isLogin!: boolean;
  showPassword!: boolean;
  isForgotPassword!: boolean;
  isBloqueado!: boolean;
  isUserNotFound!: boolean;
  isSesionReciente: boolean;
  keepForgotLink = false;
  isLoading = false;

  dataUser!: DataToForgotPassword;

  private _unsubscribeAll: Subject<any>;

  constructor(
    private _userService: UserService,
    private _router: Router,
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private _sessionService: SessionService,
    // private _activatedRoute: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private _snackBar: MatSnackBar,
    // private _route: ActivatedRoute,
    private _prospectService: ProspectService,
    // private _splashScreenService: FuseSplashScreenService,
  ) {
    this._unsubscribeAll = new Subject();
    this.showUsername = true;
    this.isForgotPassword = false;
    this.isSesionReciente = true;
    this.savedSessions = this._sessionService.getRecents();
    this._fuseConfigService.config = {
      layout: {
        navbar: { hidden: true },
        toolbar: { hidden: true },
        footer: { hidden: true },
        sidepanel: { hidden: true },
      },
    };
    // this._activatedRoute.queryParams.subscribe(() => {});
  }

  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      username: [''],
      password: [''],
    });
    if (localStorage.getItem('idRegisterComplete')) {
      this.addAccount();
      this.processFirstUserAccess();
    } else if (sessionStorage.getItem('dataLoginUser')) {
      this.processForgotPassword();
    }

    //Comunicacion entre Login y ForgotPassword
    this._sessionService.forgotPassword$.subscribe(
      ({ isForgot, isLogin, isSesion, isBlocked }) => {
        this.isForgotPassword = isForgot;
        this.isLogin = isLogin;
        this.isSesionReciente = isSesion;
        this.isBloqueado = isBlocked;
        if (this.isBloqueado) {
          this.disabledInfo();
          this.isBloqueado = true;
          this.checkMessage();
        }
      },
    );
  }
  // eslint-disable-next-line
  onSubmit(): void {
    this.isLoading = true;
    this._userService.login(this.loginForm.value).subscribe(
      response => {
        const dataAuthKeycloak: KeycloakAuthResponse = response;
        sessionStorage.setItem('access_token', dataAuthKeycloak.access_token);
        sessionStorage.setItem('refresh_token', dataAuthKeycloak.refresh_token);
        this._userService
          .addSession(this.loginForm.value)
          ?.subscribe(responseSession => {
            const identification: IdentificationResponse = responseSession.data;
            const name = identification.firstName.split(' ');
            const lastName = identification.lastName.split(' ');
            const image = {
              image: './assets/images/default-avatar.png',
              imagenContentType: 'image/jpeg',
            };
            this._sessionService.save(
              this.loginForm.get('username')?.value,
              name[0],
              lastName[0],
              image,
            );
            this._userService
              .sendEmailAccess(this.loginForm.get('username')?.value)
              .subscribe();
            this._router.navigate(['/dashboard']);
            this._snackBar.open('Bienvenido', '', {
              verticalPosition: 'top',
              horizontalPosition: 'right',
              panelClass: ['snack-info'],
              duration: 3000,
            });
          });
      },
      error => {
        this.loginForm.get('password')?.reset();
        if (error.status === 401 || error.status === 400) {
          this.checkIsBloqueado().subscribe((isUserBlock: boolean) => {
            if (!isUserBlock && !this.isUserNotFound) {
              this.isForgotPassword = true;
              this.checkMessage();
            } else if (isUserBlock) {
              this.isForgotPassword = false;
              this.isBloqueado = true;
              this.checkMessage();
              this.sendAccountLockEmail();
            } else {
              this.isUserNotFound = true;
              this.checkMessage();
            }
          });
        }
      },
    );
  }

  get gridTemplateColumns(): string {
    // Ajusta el número de columnas según la cantidad de sesiones
    return `repeat(${Math.min(2, this.savedSessions.length)}, 130px)`;
  }

  checkPassword(): void {
    this.showPassword = !this.showPassword;
  }

  addAccount(valor: any = {}): void {
    this.username = valor.username;
    this.isLogin = true;
    this.isSesionReciente = false;
    if (valor.username) {
      this.loginForm.get('username')?.setValue(valor.username);
      this.showUsername = false;
      this.imagenLogin = valor.img;
      return;
    }
    this.showUsername = true;
  }

  isSavedSessions(): boolean {
    return this.savedSessions.length > 0;
  }

  deleteSesion(index: number): void {
    this._sessionService.delete(index);
    this.savedSessions = this._sessionService.getRecents();
  }

  checkIsBloqueado(): Observable<boolean> {
    return this._userService
      .verifyUsernameKeycloak(this.loginForm.get('username')?.value)
      .pipe(
        switchMap((userResponse: any) => {
          return of(userResponse).pipe(
            map((userData: any) => {
              userData.map((user: any) => {
                this.saveDataToForgotPassword(user);
              });
              if (userData.length > 0) {
                const userKeycloak = JSON.parse(
                  JSON.stringify(userData).slice(1, -1),
                );
                if (!userKeycloak.enabled) {
                  return true;
                }
              } else {
                this.isUserNotFound = true;
              }
              return false;
            }),
          );
        }),
      );
  }

  checkMessage(): void {
    if (this.isBloqueado) {
      this._snackBar.open('Usuario Bloqueado, Favor "Desbloquear cuenta"', '', {
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: ['snack-info'],
        duration: 3000,
      });
    } else if (this.isForgotPassword) {
      this._snackBar.open('Usuario o Contraseña invalidas', '', {
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: ['snack-info'],
        duration: 3000,
      });
    } else if (this.isUserNotFound) {
      this._snackBar.open('Usuario no registrado', undefined, {
        verticalPosition: 'top',
        horizontalPosition: 'right',
        panelClass: ['snack-error'],
      });
    }
    this.isLoading = false;
  }

  sendAccountLockEmail() {
    const email = this.loginForm.get('username')?.value;
    this._userService.sendAccountLockEmail(email).subscribe();
  }

  sanitizeImagen(imagen: any): any {
    return imagen.imagen
      ? this._sanitizer.bypassSecurityTrustResourceUrl(
          `data:${imagen.imagenContentType};base64, ${imagen.image}`,
        )
      : './assets/images/default-avatar.png';
  }

  enableInfo(): void {
    this.loginForm['controls']['password'].setValue(null);
    this.loginForm['controls']['password'].enable();
  }

  disabledInfo(): void {
    this.loginForm['controls']['password'].setValue(null);
    this.loginForm['controls']['password'].disable();
  }

  private processFirstUserAccess() {
    const idRegisterComplete = localStorage.getItem('idRegisterComplete');
    if (idRegisterComplete !== null) {
      this._prospectService
        .confirmation(JSON.parse(idRegisterComplete))
        .subscribe({
          next: response => {
            localStorage.removeItem('idRegisterComplete');
            if (!response.data) {
              this._snackBar.open(
                'Favor de verificar su acceso al sistema',
                '',
                {
                  verticalPosition: 'top',
                  horizontalPosition: 'right',
                  panelClass: ['snack-error'],
                  duration: 3000,
                },
              );
            }
          },
          error: () => {
            this._snackBar.open('Ocurrió algo', '', {
              verticalPosition: 'top',
              horizontalPosition: 'right',
              panelClass: ['snack-error'],
              duration: 3000,
            });
          },
        });
    }
  }

  private processForgotPassword() {
    const dataToFPStr = sessionStorage.getItem('dataLoginUser');
    if (dataToFPStr) {
      const dataToFP: DataToForgotPassword = JSON.parse(dataToFPStr);
      if (dataToFP.accessType.id === 1) {
        this.loginForm.get('username')?.setValue(dataToFP.username);
        this.dataRestoreForgot();
      } else if (dataToFP.accessType.id === 2) {
        this.dataRestoreForgot();
        const session = this._sessionService.getSession(dataToFP.username);
        if (session !== undefined) {
          this.addAccount(session);
        }
      }
    }
  }

  private saveDataToForgotPassword(temporalUserData: any): void {
    if (!temporalUserData) {
      return;
    }
    const firstName = temporalUserData.firstName?.split(' ');
    const lastName = temporalUserData.lastName?.split(' ');
    const idUserBlocked = temporalUserData.enabled ? 1 : 2;
    const idUserLogin = this.showUsername ? 1 : 2;
    const dataToForgotPassword: DataToForgotPassword = {
      username: temporalUserData.email,
      name: `${firstName[0]} ${lastName[0]}`,
      status: {
        id: idUserBlocked,
        description: '', //AGREGAR DESCRIPCION ACTIVO||BLOQUEADO
      },
      accessType: {
        id: idUserLogin,
        description: '', //AGREGAR DESCRIPCION saveSession || credentials
      },
    };
    sessionStorage.setItem(
      'dataLoginUser',
      JSON.stringify(dataToForgotPassword),
    );
  }

  switchLoginButton(): boolean {
    if (!localStorage.getItem('sessions') && this.showUsername) {
      return true;
    }

    const sessions: any = JSON.parse(localStorage.getItem('sessions') || '');
    if (
      this.loginForm.get('username')?.value !== '' &&
      this.loginForm.get('password')?.value !== ''
    ) {
      return true;
    }

    if (this.isLogin) {
      return sessions.some(
        (session: any) =>
          session.username === this.username &&
          this.loginForm.get('password')?.value !== '',
      );
    }
    return false;
  }

  inputPassword(): void {
    this.isForgotPassword = false;
  }

  exit(event: any): void {
    event.preventDefault();
    sessionStorage.removeItem('dataLoginUser');
    sessionStorage.removeItem('username');
    window.location.reload();
  }

  dataRestoreForgot() {
    this._sessionService.dataRestoreLoginForgot$.subscribe(data => {
      sessionStorage.setItem('dataLoginUser', JSON.stringify(data));
    });
  }

  ngOnDestroy(): void {
    if (sessionStorage.getItem('dataLoginUser')) {
      const dataStorage = JSON.parse(
        sessionStorage.getItem('dataLoginUser') || '',
      );
      this._sessionService.saveDataLoginForgot(dataStorage);
      sessionStorage.removeItem('dataLoginUser');
    }
    this._unsubscribeAll.next(void 0);
    this._unsubscribeAll.complete();
    this.isForgotPassword = false;
    this.isBloqueado = false;
  }
}
